<template>
  <div class="side-menu-wrapper">
    <img
      v-if="routes && routes.length"
      class="menuIcon"
      :class="{ collapsedIcon: collapsed }"
      :src="menuIcon"
      @click="handleCollpasedChange"
    />
    <!-- 根据routes的值渲染页面 -->
    <el-menu
      :class="collapsed ? 'collIcon text_center' : ''"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="collapsed"
      :style="{ width: sidebar.width + 'px' }"
      :router="true"
      @open="handleOpen"
      @close="handleClose"
      :collapse-transition="false">
      <slot></slot>
      <template v-for="item in routes">
        <el-menu-item
          v-if="item.type === 2 || (
            item.type === 0 && (
              !Array.isArray(item.children) ||
              !item.children.length ||
              !item.children.some(sm => sm.type === 2)
          ))"
          :index="item.route">
          <i :class="item.menuIcon"></i>
          <span slot="title">{{ item.label }}</span>
        </el-menu-item>
        <el-submenu v-else-if="[0,1].includes(item.type)" :index="item.menuId.toString()">
          <template slot="title">
            <i :class="item.menuIcon"></i>
            <el-link v-if="item.type === 0" :underline="false" @click="$router.push({name: item.route})" class="white">{{ item.label }}</el-link>
            <span v-else>{{ item.label }}</span>
          </template>
          <template v-for="subMenu in item.children">
            <el-menu-item v-if="subMenu.type === 2 && !subMenu.hidden" :index="subMenu.route">
              <span slot="title">{{ subMenu.label }}</span>
            </el-menu-item>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import config from "@/config";
export default {
  data() {
    return {
      menuIcon: require("@/assets/image/menuIcon.svg")
    };
  },
  computed: {
    ...mapGetters(["collapsed", "sidebar"]),
    admin() {
      let type = config.user.role.type !== 4;
      return type;
    },
    routes() {
      return this.$store.state.permission.routes;
    }
  },
  methods: {
    handleCollpasedChange() {
      this.$store.dispatch("setLeftCollapse"); // 折叠菜单
      this.$store.dispatch("handleLeftMenu"); // 改变菜单宽度 180->35/35-180
    },
    handleOpen(key, keyPath) {},
    handleClose(key, keyPath) {}
  }
};
</script>

<style lang="less">
// .side-menu-wrapper {
//   position: relative;
// }
.menuIcon {
  width: 18px;
  height: 40px;
  // position: fixed;
  position: absolute;
  top: 72px;
  left: 208px;
  border-radius: 100px;
  z-index: 1;
  cursor: pointer;
  transition: all 0.2s;
}
.collapsedIcon {
  left: 48px;
  top: 72px;
}
.el-menu-item {
  padding-left: 6px !important;
}
</style>
